3) Selecione o aplicativo chamado
          <strong>
          {{applicationName}}
          </strong>, App ID
          <strong>
          {{applicationId}}
          </strong>.
        